var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalLoader',{attrs:{"visible":_vm.globalLoaderVisible,"text":_vm.$t('Common.loading')}})}
var staticRenderFns = []

export { render, staticRenderFns }